import SearchTracking from 'utils/search-tracking';
import { Page } from 'utils/page-utils';
import getParkingType from 'segment/utils/parking-type';
import ErrorUtils from 'utils/error-utils';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { selectEventId, selectSearchRequest, selectAirport, selectCitySlug, } from '../selectors/noResultsSelectors';
const headingmsg = 'No results found';
const errormsg = `To see available parking, you can try running a search again or explore options in the closest city to you`;
export const useNoResultsSegmentProperties = (numFilters) => {
    const eventId = useSelector(selectEventId);
    const { monthly, search_string: searchQuery, pageType } = useSelector(selectSearchRequest);
    const airport = useSelector(selectAirport);
    const citySlug = useSelector(selectCitySlug);
    return useMemo(() => {
        const coreProperties = {
            message: headingmsg,
            errorMessage: numFilters > 0
                ? `But don't worry, there are a few things you can try to broaden your search: Consider removing the filters to see all available spots. Zoom out on the map to expand your search area. Sometimes, there are great options just a little further away.`
                : errormsg,
            action: numFilters > 0 ? 'remove filters' : 'no available spots',
            screen: 'search',
            errorHeader: numFilters > 0
                ? `We couldn't find any nearby spots that match the filters you applied.`
                : `We couldn't find any available spots nearby`,
            currentScreenName: 'search',
        };
        try {
            const isEvent = Boolean(eventId);
            const isEventPackage = pageType === Page.EVENT_PACKAGES_SEARCH;
            const { searchUUID } = SearchTracking.getValues();
            const parkingType = getParkingType({
                isMonthly: monthly,
                isAirport: airport,
                isEvent,
                isEventPackage,
            });
            return {
                ...coreProperties,
                city: citySlug,
                pageType,
                parkingType,
                query: searchQuery,
                searchId: searchUUID,
            };
        }
        catch (error) {
            ErrorUtils.sendSentryMessage({
                // STRICT - @ts-expect-error fix when typed
                customErrorMessage: 'SpotListNoResults: Error getting segment properties',
                error,
            });
            return coreProperties;
        }
    }, [
        numFilters,
        eventId,
        monthly,
        searchQuery,
        pageType,
        airport,
        citySlug,
    ]);
};
